import React, {Component} from 'react'
import Card, {CardContent} from 'material-ui/Card'
import Article from './article'
import axios from 'axios'
import {server} from './constants'
import Player from './player'


class Introduction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: ''
        };
    }

    componentDidMount() {
        let self = this;
        axios.get(server + 'introduction/', {}).then(function (response) {
            self.setState({text: response.data.text})
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    render() {

        return (
            <Card>
                <CardContent>
                    <Player text={this.state.text} lang="br"/>
                    <Player text={this.state.text} lang="pt"/>
                </CardContent>
                <Article text={this.state.text}/>
            </Card>
        )
    }
}

export default Introduction


// WEBPACK FOOTER //
// ./src/introduction.jsx